import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { BASE_URL } from '../../config/config';
import { NgxSpinnerService } from "ngx-spinner"; 
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class HomeService {
  public DASBOARD_URL = BASE_URL.URL;
  private userId: any;
 
  constructor(
    private http: HttpClient, 
    private spinnerService: NgxSpinnerService, 
    private route: Router
  ) { }

  getStoreDetails(): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores?fields=id,name&counts=cabinets,stocks`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res 
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getStockDetails(stockId: string): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/${stockId}/stocks?counts=active,consumed,missing,expiring,expired,low_stocks`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe( 
        map((res: any) => {        
          return res 
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getWarehouseDetails(): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/warehouses/4/products?counts=active,expiring,expired`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    }).pipe(  
      map((res: any) => res), 
      tap(() => this.spinnerService.hide()),
      catchError(this.handleError.bind(this))
    );
  }
 
  getStoreName(stockId: string): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/${stockId}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res 
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  closeAlert(id: number): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');
    return this.http.get(`${this.DASBOARD_URL}/alerts/close?id=${id}`,{  // Use post instead of get if closing an alert
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
    .pipe(
      map((res: any) => res),
      tap(() => this.spinnerService.hide()),
      catchError(this.handleError.bind(this))
    );
  }

  editUser(userId: string|number, data): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.put(`${this.DASBOARD_URL}/users/${userId}`, data,{
        headers: {
          'Authorization': 'Bearer ' + token 
        }
      })
      .pipe( 
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getDesktopDevice(storeId: string, descValue: String, search: string = "", stockReadValue: String): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/${storeId}/devices?device_type=desktop${descValue ? `&last_updated_at=${descValue}` : ''}&search=${search}${stockReadValue ? `&stock_count=${stockReadValue}` : ''}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getDesktopDownload(storeId: string, deviceId: string,){
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/${storeId}/devices/${deviceId}/summary?download=0` , {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      ); 
  }

  getHandheldDevice(storeId: string, descValue: String, search: string = "", stockReadValue: String): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/${storeId}/devices?device_type=handheld${descValue ? `&last_updated_at=${descValue}` : ''}&search=${search}${stockReadValue ? `&stock_count=${stockReadValue}` : ''}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getDesktopSummary(storeId: string, deviceId: string, stockValue: String, users: Array<String> = [], search: string = ""): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/${storeId}/devices/${deviceId}/summary?download=0${stockValue ? `&last_updated_at=${stockValue}` : ''}&username=${users}&search=${search}` , {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      ); 
  }

  editDesktop(id: string, desktopData: any): Observable<any> {
    this.spinnerService.show();
    const token = localStorage.getItem('token');
    const headers = { 'Authorization': `Bearer ${token}` };
    return this.http.post(`${this.DASBOARD_URL}/cabinets/${id}`, desktopData, { headers })
      .pipe(
        tap(() => this.spinnerService.hide()),
        map((res: any) => res),
        catchError(this.handleError.bind(this))
      );
  }

  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }else if(error.status === 422){
      this.spinnerService.hide();
      return throwError(()=> error);
    }
    else{
      this.spinnerService.hide();
      return throwError(()=> error);
    }

  }

}
